import type { Custodian } from 'models/custodian';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { TradeSizeInputMode } from 'state/secondaryMarket/shared/tradeInformation.models';
import type { Collection } from 'state/utils/types';

import type { TradeWay } from '../../../secondaryMarket.model';
import type { ClientType } from '../../../shared/form.models';
import type { CpOrderSettlementType } from '../../referential/client/client.model';

export const availableTradeDateTypes = ['SameAsValuationDate', 'SameAsCobDate'] as const;
export type TradeDateType = (typeof availableTradeDateTypes)[number];

export type SecondaryMarketCpOrderForm = Readonly<{
  cashAmount?: number;
  tradeSizeInputMode: TradeSizeInputMode;
  client?: ISalesCounterpart;
  clientType?: ClientType;
  comment?: string;
  quantity?: number;
  firstSettlementDate?: string;
  settlementDate?: string;
  valuationDate?: string;
  tradingPrice?: number;
  custodian?: Custodian;
  tradeDateType?: TradeDateType;
  tradeWay?: TradeWay;
  upfront?: number;
  salesMargin?: number;
  salesId?: string;
  salesDesk?: string;
  settlementType?: CpOrderSettlementType;
}>;

export type SecondaryMarketCpOrderFormMap = Collection<SecondaryMarketCpOrderForm>;
export type SecondaryMarketCpOrderField = keyof SecondaryMarketCpOrderForm;
export type SecondaryMarketCpOrderFormTabContent = SecondaryMarketCpOrderForm & {
  bcsProductKey: string;
};
export const initialCpOrderFormMap: SecondaryMarketCpOrderFormMap = {};

export const initialCpOrderForm: SecondaryMarketCpOrderForm = {
  tradeSizeInputMode: undefined,
};

export const defaultCpOrderForm: SecondaryMarketCpOrderForm = {
  clientType: 'Other',
  tradeDateType: 'SameAsValuationDate',
  tradeWay: undefined,
  tradeSizeInputMode: undefined,
};
